<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ActionButton',
});
</script>
<script setup lang="ts">
import type { StyleValue } from 'vue';

/**
 * 操作按钮组件 (ActionButton)
 * 封装了带 Tooltip 提示的图片按钮风格
 */
interface Props {
  /** 图标路径 */
  icon?: string;
  /** 提示内容 */
  content?: string;
  /** 提示层位置，默认 top */
  placement?: string;
  /** 自定义图标样式 */
  customStyle?: StyleValue;
}

;

const props = withDefaults(defineProps<Props>(), {
  placement: 'top',
  customStyle: () => ({
    width: '20px',
    height: '20px',
    margin: '5px',
    cursor: 'pointer',
  }),
});

const emit = defineEmits(['click']);

const onClick = (event: MouseEvent) => {
  emit('click', event);
};
</script>

<template>
  <div>
  <el-tooltip
    v-if="props.content"
    class="box-item"
    effect="dark"
    :content="props.content"
    :placement="props.placement as any"
  >
    <img
      :src="props.icon"
      :style="props.customStyle"
      class="action-btn-img"
      alt="action-button"
      @click="onClick"
    />
  </el-tooltip>
  <img
    v-else
    :src="props.icon"
    :style="props.customStyle"
    class="action-btn-img"
    alt="action-button"
    @click="onClick"
  />
  </div>
</template>

<style scoped lang="scss">
.action-btn-img {
  display: block;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }
}
</style>
